/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from 'react';

const CategoryGrid = ({ categories, selectedCategory, selectedSubCategory, onCategoryClick, theme }) => (
  <section id="categories-section" className="container mx-auto px-4 sm:px-8 py-8 sm:py-12">
    {/* عنوان القسم محاذى لليمين */}
    <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-6 sm:mb-8 text-right">الأقسام</h2>

    <div className="categories-scroll flex sm:grid sm:grid-cols-3 md:grid-cols-5 gap-3 sm:gap-4 overflow-x-auto sm:overflow-visible pb-2 sm:pb-0 snap-x snap-mandatory">
      {categories.map((cat, idx) => {
        const isActive = selectedCategory === cat.id;
        return (
          <div key={`cat-${cat.id}-${idx}`} className="flex flex-col gap-1 sm:gap-2 items-stretch min-w-[280px] sm:min-w-0 snap-start">
            {/* Main Category Card */}
            <div
              onClick={() => onCategoryClick(cat.id)}
              className={`w-full min-h-[72px] bg-white py-3 sm:py-4 px-4 sm:px-6 rounded-xl shadow-sm border transition-all flex flex-row-reverse items-center justify-center gap-2 sm:gap-3 cursor-pointer hover:shadow-md
                ${isActive ? 'ring-1 shadow-md scale-[1.02]' : 'border-gray-100'}
              `}
              style={isActive ? {
                borderColor: theme?.primary || '#5B4DFF',
                '--tw-ring-color': theme?.primary || '#5B4DFF',
              } : {}}
            >
              <span className="font-bold text-gray-700 text-sm sm:text-sm text-center sm:text-right leading-5 whitespace-normal break-words">
                {cat.name}
              </span>
              <span className="text-lg sm:text-xl">{cat.icon}</span>

              {cat.count > 0 && (
                <span className="text-[9px] sm:text-[10px] text-gray-400 font-semibold">({cat.count})</span>
              )}
            </div>

            {/* Sub-categories */}
            {isActive && cat.subCategories?.length > 0 && (
              <div className="flex flex-wrap justify-center sm:justify-start gap-1 sm:gap-2 mt-1 animate-fadeIn">
                {cat.subCategories.map(sub => {
                  const isSubActive = selectedSubCategory === sub.id;
                  return (
                    <button
                      key={`sub-${sub.id}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        onCategoryClick(cat.id, sub.id);
                      }}
                      className={`px-2 sm:px-3 py-1 rounded-full text-[9px] sm:text-xs font-bold transition-all border
                        ${isSubActive
                          ? 'text-white shadow-md'
                          : 'bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100'
                        }
                      `}
                      style={isSubActive ? {
                        backgroundColor: theme?.primary || '#5B4DFF',
                        borderColor: theme?.primary || '#5B4DFF',
                      } : {}}
                    >
                      {sub.name}
                      {sub.count > 0 && (
                        <span className={`mr-1 opacity-70 ${isSubActive ? 'text-white' : 'text-gray-400'}`}>
                          ({sub.count})
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>

    <style>{`
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-6px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .categories-scroll::-webkit-scrollbar {
        height: 6px;
      }
      .categories-scroll::-webkit-scrollbar-thumb {
        background: #d1d5db;
        border-radius: 9999px;
      }
      .animate-fadeIn {
        animation: fadeIn 0.25s ease-out;
      }
    `}</style>
  </section>
);

export default CategoryGrid;
